import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ShieldCaution16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M8.74988 4V9H7.24988V4H8.74988Z' fill='currentColor' />
    <path
      d='M8.99988 11C8.99988 11.5523 8.55216 12 7.99988 12C7.44759 12 6.99988 11.5523 6.99988 11C6.99988 10.4477 7.44759 10 7.99988 10C8.55216 10 8.99988 10.4477 8.99988 11Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.69676 0.302765C7.89581 0.253001 8.10405 0.253001 8.3031 0.302763L13.8032 1.67776C14.3596 1.81688 14.75 2.31686 14.75 2.89044V11.2129C14.75 11.6575 14.5139 12.0686 14.1298 12.2926L8.62977 15.5009C8.24056 15.728 7.75929 15.728 7.37009 15.5009L1.87016 12.2926C1.48614 12.0686 1.25 11.6575 1.25 11.2129V2.89044C1.25 2.31686 1.64037 1.81688 2.19683 1.67776L7.69676 0.302765ZM7.99993 1.77314L2.75 3.08563V11.0693L7.99994 14.1318L13.25 11.0693V3.08564L7.99993 1.77314Z'
      fill='currentColor'
    />
  </Svg>
);

ShieldCaution16.displayName = 'ShieldCaution16';
export default ShieldCaution16;
